var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"previews"},_vm._l((_vm.payloads),function(payload,i){return _c('div',{key:i,staticClass:"group_preview",style:({
            zIndex: _vm.payloads.length - i,
            transform: ("translateX(0%)  rotateZ(" + ((i - _vm.payloads.length / 2) * _vm.rotateDeg) + "deg)"),
        })},[_c('NftPayloadView',{attrs:{"payload":payload,"small":true}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }